import React,{useState,useEffect} from "react";
import MasterLeftPanel from "../include/MasterLeftPanel";
import Header from "../include/header";
import Footer from "../include/footer";
import Global from "../../APIConfig";
import  axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useParams,useLocation } from "react-router-dom";
import AuthUser from "../../AuthUser";
import MainLoader from "../Loaders/MainLoader";
import ListLoader from "../Loaders/ListLoader";
import {CopyToClipboard} from 'react-copy-to-clipboard';


function ServiceList()
{
    const navigate = useNavigate();
    const {type} = useParams();
    const location = useLocation();
    const [list, setList] = useState([]);
    const [showpage, setShowpage] = useState(type);
    const{headers1,headers2,logout}=AuthUser();
    const [Loading, setLoading] = useState(true);
    const [Subloading, setSubloading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1); // Total number of pages
    const [nextPageUrl, setNextPageUrl] = useState(null);
    const [prevPageUrl, setPrevPageUrl] = useState(null);
    const pageRangeDisplayed = 2; 
    const [searchTerm, setSearchTerm] = useState('');
    
    useEffect(()=>{
        const query = new URLSearchParams(location.search);
        const page = query.get('page') ? parseInt(query.get('page'), 10) : 1;
        const search = query.get('search') || '';
        setCurrentPage(page);
        setSearchTerm(search);
        GetServicelist(page,type,search);
    },[location.search]);
    
    const GetServicelist=(page=1,type,searchvalue)=>{
        setSubloading(true);
        setShowpage(type);
        axios({
            method: 'post',
            url: Global.baseUrl+'GetServicelist',
            headers:headers1,
            data: {
                pagetype:type,
                searchvalue: searchvalue
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value.data;
                setList(data);
                setCurrentPage(response.data.value.current_page);
                setLastPage(response.data.value.last_page);
                setNextPageUrl(response.data.value.next_page_url); // URL for next page
                setPrevPageUrl(response.data.value.prev_page_url); // URL for previous page
            }
            else
            {
                setList();
            }
            setSubloading(false);
            setLoading(false);
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            setSubloading(false);
            setLoading(false);
            // console.log(error);
          });
    }

    const handleservicestatus=(unique_id,val)=>{
        setSubloading(true);
        axios({
            method: 'post',
            url: Global.baseUrl+'Statusupdate',
            headers:headers1,
            data: {
                unique_id:unique_id,
                status: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                GetServicelist('',showpage,'');
                toast.success(response.data.message);
            }
            else
            {
                toast.warn(response.data.message);
            }
            setSubloading(false);
          })   
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            setSubloading(false);
            // console.log(error);
          });
    }

    const Servicedeleted=(id)=>{
        if (window.confirm('Do You  want to delete ?')) {
            setSubloading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'ServiceDelete',
                headers:headers1,
                data: {
                    unique_id:id
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                   toast.success(response.data.message);
                }
                else
                {
                    toast.warn(response.data.message);
                }
                setSubloading(false);
              })
              .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                setSubloading(false);
                // console.log(error);
              });
              GetServicelist('',type,'');
          } 
        //   else {
        //     GetServicelist(type,'');
        //   }
        
    }

    // Update the URL and fetch the data for the selected page
const handlePageChange = (pageNumber) => {
    const query = new URLSearchParams(location.search);
    query.set('page', pageNumber);
    navigate(`?${query.toString()}`);
  };
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const query = new URLSearchParams(location.search);
    query.set('search', searchTerm);
    query.set('page', 1); // Reset to page 1 on a new search
    navigate(`?${query.toString()}`);
  };
  // Handle Previous button click
  const handlePreviousPage = () => {
    if (prevPageUrl) {
      handlePageChange(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNextPage = () => {
    if (nextPageUrl) {
      handlePageChange(currentPage + 1);
    }
  };

// Create pagination items for each page, showing a limited number of page numbers with ellipses
const renderPageNumbers = () => {
    const pages = [];

    // Always show the first page
    if (currentPage > pageRangeDisplayed + 1) {
      pages.push(
        <li key={1} className="page-item">
          <button className="page-link" onClick={() => handlePageChange(1)}>1</button>
        </li>
      );
      pages.push(<li key="start-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
    }

    // Show the range of pages around the current page
    for (let i = Math.max(1, currentPage - pageRangeDisplayed); i <= Math.min(lastPage, currentPage + pageRangeDisplayed); i++) {
      pages.push(
        <li key={i} className={`page-item ${i === currentPage ? 'active' : ''}`}>
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    // Always show the last page
    if (currentPage < lastPage - pageRangeDisplayed) {
      pages.push(<li key="end-ellipsis" className="page-item disabled"><span className="page-link">...</span></li>);
      pages.push(
        <li key={lastPage} className="page-item">
          <button className="page-link" onClick={() => handlePageChange(lastPage)}>{lastPage}</button>
        </li>
      );
    }

    return pages;
  };
    
    return (
        <>
        <MasterLeftPanel/>
        <main className='home-section'>
            <Header/>
            <ToastContainer/>
            {Loading==true ? <MainLoader/> :
            <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="/Admin-Dash">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Price Master</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">{showpage} Price Master</h2>
                        </div>
                    </div>
                </div>
                
                <div className="btn-toolbar mb-2 mb-md-0">
                    <div className="dropdown">
                        <button className="btn btn-primary d-inline-flex align-items-center me-2 dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <svg className="icon icon-xs me-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>
                            New 
                        </button>
                        <div className="dropdown-menu dashboard-dropdown dropdown-menu-start mt-2 py-1">
                            <a className="dropdown-item d-flex align-items-center" href="/ServiceAdd">
                                <i className="bx bx-rocket text-primary-400 me-2 fs-5"></i>
                                Add New Service
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md">
                    <div className="custom_nav_data_table">
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <a href="/ServiceList/All" className={showpage =='All'? "nav-link active":"nav-link"}>All Services</a>
                            </li>
                            <li className="nav-item">
                                <a href="/ServiceList/Domestic" className={showpage =='Domestic'? "nav-link active":"nav-link"}>Domestic Services</a>
                            </li>
                            <li className="nav-item">
                                <a href="/ServiceList/International" className={showpage =='International'? "nav-link active":"nav-link"}>International Services</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-12 col-md-4">
                    <div className="table-settings shipment_list" id="">
                        <div className="row align-items-start g-2" >
                            <div className="col col-md ">
                            <form onSubmit={handleSearchSubmit}>
                                    <div className="input-group ">
                                        <input type="text" className="form-control w-50" placeholder="Search service" onChange={handleSearchChange} />
                                        <button type="submit" className="input-group-text">
                                            <i className="bx bx-search"></i>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="data_table">
                <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                    <table className="table table-hover">
                        <thead>
                            <tr>						
                                <th className="border-gray-200">#</th>
                                <th className="border-gray-200">Service Unique Id</th>
                                <th className="border-gray-200">Service Name</th>
                                <th className="border-gray-200">Shipment Type</th>
                                <th className="border-gray-200">Mode</th>
                                <th className="border-gray-200">Weight Range</th>
                                <th className="border-gray-200">Status</th>
                                <th className="border-gray-200">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        {Subloading==true && <ListLoader/>}
                        {list!=undefined && list.length>0 && Subloading==false ?
                             <>
                             {list.map((service,index)=>{
                                 return(
                                     <tr key={index}>
                                <td><span className="fw-normal text-capitalize">{index+1}</span></td>
                                <td><span className="fw-normal text-capitalize"><Link to={`/ServiceEdit/${service.unique_id}`}>{service.unique_id}</Link></span> <CopyToClipboard text={service.unique_id} onCopy={()=>{toast.success(service.unique_id+' Copied To Clipboard')}}><i className="bx bx-copy"></i></CopyToClipboard></td>
                                <td><span className="fw-normal text-capitalize"><Link to={`/ServicePricing/${service.unique_id}/${service.booking_type}`}>{service.services_name}</Link> </span></td>
                                <td><span className="fw-normal"><span className={service.product_type=='Parcel'? "badge bg-danger":"badge bg-warning"}>{service.product_type}</span></span></td>
                                <td><span className="fw-normal"><span className={service.booking_type=='Domestic' ? "badge bg-primary":"badge bg-dark"}>{service.booking_type}</span></span></td>
                                <td><span className="fw-normal text-capitalize">{service.startrange} ~ {service.endrange}KG</span></td>
                                <td>
                                    <div className="form-check form-switch  mb-2">
                                       <input className="form-check-input" type="checkbox" role="switch" checked={service.status=='Y'? true : false} onChange={()=>{service.status=='Y'? handleservicestatus(service.unique_id,'N'):handleservicestatus(service.unique_id,'Y')}} />
                                    </div>
                                </td>
                                <td>
                                    <Link to={`/ServiceEdit/${service.unique_id}`} className="btn btn-gray-100">Update Service</Link>
                                    <Link to={`/ServicePricing/${service.unique_id}/${service.booking_type}`} className="btn btn-gray-100">Set/Update Pricing</Link>
                                    <Link to={`/ServiceOtherPricing/${service.unique_id}`} className="btn btn-gray-100">Set/Update OtherPricing</Link>
                                    <button type="button" className="btn btn-gray-100" onClick={()=>Servicedeleted(service.unique_id)}>Service Delete</button>
                                </td>
                            </tr> 
                            );
                        })}   
                    </>
                        :
                        <tr>
                           <td colSpan="8" className="text-center text-danger">Record Not Found</td>
                        </tr>
                       }                    
                        </tbody>
                    </table>
                    
                </div>
            </section>

            <div className="card-footer px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
                <nav aria-label="Page navigation example">
                    <ul className="pagination mb-0">
                    {/* Previous Button */}
                    <li className={`page-item ${!prevPageUrl ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={handlePreviousPage} disabled={!prevPageUrl}>
                        Previous
                        </button>
                    </li>

                    {/* Page Numbers */}
                    {renderPageNumbers()}

                    {/* Next Button */}
                    <li className={`page-item ${!nextPageUrl ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={handleNextPage} disabled={!nextPageUrl}>
                        Next
                        </button>
                    </li>
                    </ul>
                </nav>
                {/* <div className="fw-normal small mt-4 mt-lg-0">Showing <b>5</b> out of <b>25</b> entries</div> */}
            </div>
            </>
            }
            <Footer/>
        </main>
    </>
    );

}
export default ServiceList;